import { render, staticRenderFns } from "./TableInspectionGroup.vue?vue&type=template&id=e596c6fe&scoped=true&"
import script from "./TableInspectionGroup.vue?vue&type=script&lang=js&"
export * from "./TableInspectionGroup.vue?vue&type=script&lang=js&"
import style0 from "./TableInspectionGroup.vue?vue&type=style&index=0&id=e596c6fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e596c6fe",
  null
  
)

export default component.exports